module.exports = __webpack_public_path__ + "static/media/logo_sade_negro.b5b0dde8.png";